import { FC, useMemo } from 'react'

import { PinchZoomContainer } from '../../components'
import { DistrictDivision } from '../../entities/DistrictDivision/DistrictDivision'
import { Setting } from '../../entities/Setting/Setting'
import PrintableBlockOffsetsProvider from './contexts/PrintableBlockOffsetsContext'
import { getPrintableDistrictDivisionPages } from './helpers'
import { PrintableDistrictDivisionPages } from './subcomponents'

import './PrintableDistrictDivision.scss'

interface PrintableDistrictDivisionProps {
    isViewMode?: boolean
    districtDivision: DistrictDivision
    settings: Setting[]
    className?: string
}

const PrintableDistrictDivision: FC<PrintableDistrictDivisionProps> = ({
    isViewMode = false,
    districtDivision,
    settings,
    className = '',
}) => {
    const page = useMemo(() => getPrintableDistrictDivisionPages(districtDivision), [districtDivision])

    // The view mode only shows the unsplit sizer page. It's rendered without a PrintableBlockOffsetsProvider,
    // so it doesn't measure anything and can't interfere with the offsets of the printed version.
    if (isViewMode) {
        return (
            <PinchZoomContainer className={`printable-district-division printable-district-division--is-view-mode ${className}`}>
                <div className="printable-district-division__sheet">
                    <PrintableDistrictDivisionPages
                        page={page}
                        settings={settings}
                    />
                </div>
            </PinchZoomContainer>
        )
    }

    return (
        <PrintableBlockOffsetsProvider>
            <div className={`printable-district-division ${className}`} data-printable="true">
                <PrintableDistrictDivisionPages
                    page={page}
                    settings={settings}
                />
            </div>
        </PrintableBlockOffsetsProvider>
    )
}

export default PrintableDistrictDivision
